export default "__VITE_ASSET__CYMLYjoE__"